import { memo, useState } from "react";
import { useNavigate } from "react-router";
import { VerifyOtp } from "../../services/userService";

const ConfirmRegistration = () => {

    const [username, setUserName] = useState("");
    const [code, setCode] = useState("");
    const history = useNavigate();

    const handleSubmit = async () => {
        try {
            const confirmedSignUp = await VerifyOtp({username:username,code:code})
            history('/login')
    
        } catch (error) {
            console.log('error confirming sign up', error);
        }
       
    }

    return (
        <form onSubmit={handleSubmit}>
            <input
                className="input"
                type="text"
                id="username"

                placeholder="Enter username"
                value={username}
                onChange={(event) => setUserName(event.target.value)}
            />
            <input
                className="input"
                type="text"
                id="otp"

                placeholder="Enter OTP"
                value={code}
                onChange={(event) => setCode(event.target.value)}
            />
            <div className="field">
                        <p className="control">
                            <button className="button is-success">
                                Confirm
                            </button>
                        </p>

                    </div>

        </form>

    )

}

export default memo(ConfirmRegistration);